import format from 'date-fns/format';
import { priceFromAPI } from 'utils/price';
import { CURRENCY_SYMBOL } from 'utils/transform';
import { DATE_WITH_HOUR, MONTH_DAY_HOUR } from 'utils/dateFormat';
import { Link } from 'react-router-dom';
import PATHS from 'routes/paths';

export const TR1 = {
  id: 'TR_12121',
  created_at: format(new Date('2021-08-04T09:54:15.000000Z'), DATE_WITH_HOUR),
  merchantRef: 'XPOasd_as',
  fraudScore: '123',
  amount: `${CURRENCY_SYMBOL['EUR']}${priceFromAPI('1212')}`,
  status: 'Authorized',
  net: `${CURRENCY_SYMBOL['EUR']}${priceFromAPI('62622')}`,
  psp: 'ZXC_12341',
};
export const TR2 = {
  company: 'Blueline',
  orderId: (
    <Link className="text-javelin-blue" to={`${PATHS.orders}/8767564`}>
      8767564
    </Link>
  ),
  cardId: '1234',
  statement: '-',
  failure: '-',
  last: format(new Date('2021-08-04T09:54:15.000000Z'), DATE_WITH_HOUR),
  liability: true,
};

export const CUSTOMER1 = {
  customer_name: 'Jane Doe',
  email: 'jane@email.com',
  country: (
    <div className="flex items-center">
      <span className="mr-1.5">44</span>
      <span
        className={`w-6 h-auto lg:w-7 bg-no-repeat bg-center bg-contain flag-icon flag-icon-gb`}
      ></span>
    </div>
  ),
  phone: '-',
  ref: '-',
};
export const CUSTOMER2 = {
  card_holder: '-',
  paymentMethod: '-',
  summary: '-',
  expiry: '08/22',
  postal: 'xxx',
};

export const FEE1 = {
  amount: `${CURRENCY_SYMBOL['EUR']}${priceFromAPI('0')}`,
  txtpay: `${CURRENCY_SYMBOL['EUR']}${priceFromAPI('20')}`,
  rebate: `${CURRENCY_SYMBOL['EUR']}${priceFromAPI('30')}`,
  processing: `${CURRENCY_SYMBOL['EUR']}${priceFromAPI('200')}`,
};
export const FEE2 = {
  schemeFee: `${CURRENCY_SYMBOL['EUR']}${priceFromAPI('1000')}`,
  net: `${CURRENCY_SYMBOL['EUR']}${priceFromAPI('1200080')}`,
  schemeFeeType: `${CURRENCY_SYMBOL['EUR']}${priceFromAPI('-')}`,
};

export const EVENTS = [
  {
    id: '134562199',
    date: new Date('2021-08-04T09:54:15.000000Z'),
  },
  {
    id: '555',
    date: new Date('2021-07-26T20:15:19.000000Z'),
  },
  {
    id: '1234',
    date: new Date('2021-04-30T19:51:12.000000Z'),
  },
  {
    id: '44234',
    date: new Date('2021-09-30T19:51:12.000000Z'),
  },
  {
    id: '111',
    date: new Date('2021-11-03T19:51:12.000000Z'),
  },
  {
    id: '2341',
    date: new Date('2021-12-30T05:03:00.000000Z'),
  },
  {
    id: '9399',
    date: new Date('2021-04-30T10:01:20.000000Z'),
  },
];
export const CHARGEBACK = [
  { id: 9, amount: `€${priceFromAPI(48178)}`, event: 'Chargeback' },
  { id: 10, amount: `€${priceFromAPI(2489178)}`, event: 'Chargeback' },
  { id: 11, amount: `€${priceFromAPI(15300)}`, event: 'Chargeback' },
  { id: 12, amount: `€${priceFromAPI(45240)}`, event: 'Chargeback' },
  { id: 255, amount: `€${priceFromAPI(24990)}`, event: 'Chargeback' },
];

export const ACTIONS = [
  {
    id: 12349,
    name: '-',
    initiated_by: '-',
    target: '-',
    status: '-',
    created_at: '-',
  },
];
export const TRANSACTIONS = [
  {
    id: 26,
    status: 'Settled',
    email: 'jane@mail.com',
    amount: `€${priceFromAPI(2489178)}`,
    event: 'Refund',
    date: format(new Date('2021-07-26T20:15:19.000000Z'), MONTH_DAY_HOUR),
  },
  {
    id: 27,
    status: 'Settled',
    email: 'jane@mail.com',
    amount: `€${priceFromAPI(15300)}`,
    event: 'Chargeback',
    date: format(new Date('2021-07-26T20:15:19.000000Z'), MONTH_DAY_HOUR),
  },
  {
    id: 28,
    status: 'Settled',
    email: 'jane@mail.com',
    amount: `€${priceFromAPI(45240)}`,
    event: 'Payment',
    date: format(new Date('2021-07-26T20:15:19.000000Z'), MONTH_DAY_HOUR),
  },
  {
    id: 29,
    status: 'Settled',
    email: 'jane@mail.com',
    amount: `€${priceFromAPI(24990)}`,
    event: 'Refund',
    date: format(new Date('2021-07-26T20:15:19.000000Z'), MONTH_DAY_HOUR),
  },
  {
    id: 30,
    status: 'Settled',
    email: 'jane@mail.com',
    amount: `€${priceFromAPI(5000)}`,
    event: 'Chargeback',
    date: format(new Date('2021-07-26T20:15:19.000000Z'), MONTH_DAY_HOUR),
  },
];
export const REFUNDS = [
  {
    id: 12345,
    fee: `€${priceFromAPI(100)}`,
    amount: `€${priceFromAPI(15550)}`,
    reason: 'Requested by customer',
    status: 'Refunded',
    created_at: format(new Date('2021-08-01T15:03:20.000000Z'), DATE_WITH_HOUR),
  },
  {
    id: 12346,
    fee: `€${priceFromAPI(100)}`,
    amount: `€${priceFromAPI(15550)}`,
    reason: 'Requested by customer',
    status: 'Refunded',
    created_at: format(new Date('2021-08-01T15:03:20.000000Z'), DATE_WITH_HOUR),
  },
  {
    id: 12347,
    fee: `€${priceFromAPI(100)}`,
    amount: `€${priceFromAPI(15550)}`,
    reason: 'Requested by customer',
    status: 'Refunded',
    created_at: format(new Date('2021-08-01T15:03:20.000000Z'), DATE_WITH_HOUR),
  },
  {
    id: 12348,
    fee: `€${priceFromAPI(100)}`,
    amount: `€${priceFromAPI(15550)}`,
    reason: 'Requested by customer',
    status: 'Refunded',
    created_at: format(new Date('2021-08-01T15:03:20.000000Z'), DATE_WITH_HOUR),
  },
  {
    id: 12349,
    fee: `€${priceFromAPI(100)}`,
    amount: `€${priceFromAPI(15550)}`,
    reason: 'Requested by customer',
    status: 'Refunded',
    created_at: format(new Date('2021-08-01T15:03:20.000000Z'), DATE_WITH_HOUR),
  },
];
